import React from "react";
import { VMBuilder } from "../../../commons/base/providers/builder";
import FormOpsReminderListViewModel from "../view_models/form_ops_reminder_list_view_model";
import OutletTypeDropdownWidget from "../../widgets/outlet_type_dropdown_widget";
import { OutletType } from "../../models/outlet_type_enum";
import OutletSelectionToggleWidget from "../../widgets/outlet_selection_toggle_widget";

export default class FormOpsReminderListSendModalWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<FormOpsReminderListViewModel>>
                {(vm) => (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2"
                        onClick={() => vm.closeModal()}
                    >
                        <div
                            className="relative bg-slate-500 rounded-lg shadow-lg w-full max-w-3xl h-[83vh] flex flex-col"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="overflow-y-auto px-5 pt-5 pb-4 flex-grow">
                                <h3 className="text-lg font-bold text-white">
                                    Pilih Tipe Outlet
                                </h3>

                                <OutletTypeDropdownWidget
                                    selectedOption={vm.outletType}
                                    onChange={(value) =>
                                        vm.updateOutletType(value)
                                    }
                                />

                                {vm.outletType === OutletType.CUSTOM && (
                                    <div className="mt-4">
                                        <OutletSelectionToggleWidget
                                            outletOptions={vm.outletsInOptions}
                                            selectedOutletsMap={
                                                vm.selectedOutletsMap
                                            }
                                            onToggleOutlet={(value) =>
                                                vm.toggleOutlet(value)
                                            }
                                        />
                                    </div>
                                )}
                            </div>

                            {/* Tombol selalu di bawah */}
                            <div className="px-5 pb-5">
                                <button
                                    className="w-full bg-green-500 text-white rounded-md p-2 hover:bg-green-600 transition"
                                    onClick={() =>
                                        vm.sendOnce({
                                            onSuccess: () => vm.closeModal(),
                                        })
                                    }
                                >
                                    Kirim Sekarang
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
